function productGridSlider(){
    const allProducts = document.querySelectorAll(".grid__item");
    if(allProducts.length > 0){
    allProducts.forEach(product=>{
        let allProductsImages =product.getAttribute('data-images');
        const prevButton = product.querySelector(".prevButton");
        const nextButton = product.querySelector(".nextButton");
          let imagesArray;
          if(allProductsImages){
            imagesArray = allProductsImages.split(',');
            imagesArray.pop();
          }
          if(imagesArray && imagesArray.length > 1){
          let currentIndex = 0; // Keeps track of the currently active image index  
          function updateImage() {
            const imageElement = product.querySelector(".grid__item img");
            const updatedImages = product.querySelector('.color__swatches-swatch.active');
            if(updatedImages){
              imagesArray = [];
              imagesArray = updatedImages.getAttribute('data-productimages');
              imagesArray = imagesArray.split(',');
              imagesArray.pop();
            }
            const currentImage = imagesArray[currentIndex];
            imageElement.src = currentImage;
            if(imageElement.hasAttribute('srcset')){
              imageElement.srcset = currentImage;
            }
          }


          function onNextClick() {
            if (imagesArray.length <= 1 ) {
                return; // Do nothing
            }
            currentIndex++;
            if (currentIndex >= imagesArray.length) {
              currentIndex = 0; // Wrap around to the first image
            }
            updateImage();
          }
          function onPrevClick() {
            if (imagesArray.length <= 1 ) {
                return; // Do nothing
            }
            currentIndex--;
            if (currentIndex < 0) {
              currentIndex = imagesArray.length - 1; // Wrap around to the last image
            }
            updateImage();
          }
          
          prevButton ? prevButton.addEventListener("click", onPrevClick) : false;
          nextButton ? nextButton.addEventListener("click", onNextClick): false
        }
    })}
    
  }productGridSlider()
  